module.exports = __webpack_public_path__ + "static/img/knowledgenew5.14372f40.png";